import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { map, catchError, shareReplay, tap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../core/services/auth/auth.service';
import { MessagePopupComponent } from '../../../shared/components/message-popup/message-popup.component';
import { PopupService } from '../../../core/../core/services/popup/popup.service';

@Injectable({
	providedIn: 'root'
})

export class OfferDetailsService {

	private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
	private url = environment.do_services_sb_url;
	private userOfferMappingUrl = 'userOffers/offerMapping';
	private updateVatUrl = 'userDetails/updateVAT';
	private variantOffersUrl = 'variantOffer/getVariantOffersByAccount';

	// Caching mechanism
	private cache = new Map<string, Observable<any>>();
	private readonly CACHE_DURATION = 5 * 60 * 1000; // 5 minutes
	private cacheTimestamps = new Map<string, number>();

	constructor(private http: HttpClient, private authService: AuthService,
				private popupService: PopupService, private route: Router) { }

	userOfferMapping(offerMappinginfo: string): Observable<any> {
		let options = {
			headers: this.headers
		}
		return this.http.post(this.url + this.userOfferMappingUrl, offerMappinginfo, options)
			.pipe(
				map((response: any) => {
					const run = response;
					return run;
				}),
				catchError((e: any) => this.handleError(e))
			);
	}

	getvariantOffers(userData: string): Observable<any> {
		const cacheKey = `offers_${userData}`;
		const cachedTime = this.cacheTimestamps.get(cacheKey);
		const now = Date.now();

		// Return cached data if still valid
		if(cachedTime && (now - cachedTime) < this.CACHE_DURATION) {
			const cached = this.cache.get(cacheKey);
			if(cached) {
				return cached;
			}
		}

		// Make new request and cache it
		const request$ = this.http.post(this.url + this.variantOffersUrl, userData, { responseType: 'text' })
			.pipe(
				tap(() => this.cacheTimestamps.set(cacheKey, now)),
				shareReplay(1),
				map((response: any) => {
					return response;
				}),
				catchError((e: any) => this.handleError(e))
			);

		this.cache.set(cacheKey, request$);
		return request$;
	}

	updateVatNumber(vatInfo: string): Observable<any> {
		let options = {
			headers: this.headers
		}
		return this.http.put(this.url + this.updateVatUrl, vatInfo, options)
			.pipe(
				map((response: any) => {
					const run = response;
					return run;
				}),
				catchError((e: any) => this.handleError(e))
			);
	}

	private handleError(error: any): Observable<never> {
        if([400, 403, 404, 405, 500, 502, 503, 504].includes(error.status)) {
            return throwError(() => error);
        }
        if(error.status === 401) {
			const dialogRef = this.popupService.openDialog(MessagePopupComponent, {
				data: { message: 'Unauthorized Request - Your Session has expired' }
			});
			dialogRef.afterClosed().subscribe(() => {
				this.authService.logout().subscribe(() => {
					this.route.navigate(['/home']);
				});
			});
			return throwError(() => new Error('Unauthorized Request - Session expired'));
		}
        return throwError(() => new Error(`Unhandled status code: ${error.status}`));
    }
	/**
	 * Clear cache manually if needed
	 */
	clearCache(): void {
		this.cache.clear();
		this.cacheTimestamps.clear();
	}
}